__turbopack_context__.v({
  "button": "WidgetDetails-module-scss-module__zIJj-q__button",
  "details": "WidgetDetails-module-scss-module__zIJj-q__details",
  "fade-in": "WidgetDetails-module-scss-module__zIJj-q__fade-in",
  "no-transform": "WidgetDetails-module-scss-module__zIJj-q__no-transform",
  "rotate": "WidgetDetails-module-scss-module__zIJj-q__rotate",
});
